// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__28TbZ","date":"styles_date__ZKGFE","titleWrapper":"styles_titleWrapper__231eq","title":"styles_title__1uwux","label":"styles_label__2elO4"};